import * as React from "react";
import {
  GranteeListItemTitle,
  GranteeInfo,
  StyledGranteeIcon,
  GranteeListItemContainer
} from "components/permissions/CommonStyledComponents";
import TitleCell from "collections/components/EntitiesList/cells/TitleCell";
const CollectionGranteesListItem = ({
  grantee: { grantee, granteeName, capability, collection_name, collection_total, collection_id }
}) => {
  const capabilityRole = {
    view: "Viewer",
    manage: "Manager",
    own: "Owner"
  };
  return /* @__PURE__ */ React.createElement(GranteeListItemContainer, { $currentState: null }, /* @__PURE__ */ React.createElement(GranteeInfo, { title: granteeName }, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type: (grantee == null ? void 0 : grantee.includes("user")) ? "user" : "team" }), /* @__PURE__ */ React.createElement(GranteeListItemTitle, null, granteeName)), /* @__PURE__ */ React.createElement(GranteeInfo, null, /* @__PURE__ */ React.createElement(TitleCell, { name: collection_name, type: "collection", id: collection_id }), collection_total > 1 && /* @__PURE__ */ React.createElement("span", null, "\xA0+ ", collection_total - 1, " more")), /* @__PURE__ */ React.createElement(GranteeInfo, null, capabilityRole[capability]));
};
export default CollectionGranteesListItem;
